/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * This is an array that contains the contentTagKeys that will be active in a region
 * @export
 * @interface UpdateRegionContentTagsRequestBodyContentTags
 */
export interface UpdateRegionContentTagsRequestBodyContentTags {
  /**
   * The contentTagKey of the contentTag associated to the regionKey provided
   * @type {number}
   * @memberof UpdateRegionContentTagsRequestBodyContentTags
   */
  contentTagKey: number
}

export function UpdateRegionContentTagsRequestBodyContentTagsFromJSON(
  json: any
): UpdateRegionContentTagsRequestBodyContentTags {
  return UpdateRegionContentTagsRequestBodyContentTagsFromJSONTyped(json, false)
}

export function UpdateRegionContentTagsRequestBodyContentTagsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateRegionContentTagsRequestBodyContentTags {
  if (json === undefined || json === null) {
    return json
  }
  return {
    contentTagKey: json['contentTagKey'],
  }
}

export function UpdateRegionContentTagsRequestBodyContentTagsToJSON(
  value?: UpdateRegionContentTagsRequestBodyContentTags | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    contentTagKey: value.contentTagKey,
  }
}
